import { PaginatedResponse, BranchRequest } from '../types';
import apiService from './api';

export interface ReviewBranchRequestDto {
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  reviewNotes?: string;
}

export class BranchRequestService {
  async getPendingRequests(
    page: number = 0,
    size: number = 10
  ): Promise<PaginatedResponse<BranchRequest>> {
    return apiService.getPaginated<BranchRequest>('/api/branch-requests/pending', page, size);
  }

  async getRequestById(id: number): Promise<BranchRequest> {
    return apiService.get<BranchRequest>(`/api/branch-requests/${id}`);
  }

  async reviewBranchRequest(id: number, data: ReviewBranchRequestDto): Promise<BranchRequest> {
    return apiService.post<BranchRequest>(`/api/branch-requests/${id}/review`, data);
  }
}

export const branchRequestService = new BranchRequestService();
export default branchRequestService;
